import { useUserStore } from "@/stores/UserStore";

export const userMixin = {
  methods: {
    $can: (key) => {
      const userStore = useUserStore();
      const currentUser = userStore.currentUser;

      if (currentUser) {
        let permissions = currentUser.permissions.map((u) => u.name);
        if (userStore.currentAppClient) {
          permissions =
            currentUser.permissions
              ?.filter((p) => !p.paid_product)
              .map((u) => u.name) ?? [];
        }
        return permissions.includes(key);
      }
      return false;
    },
    $hasProduct: (product) => {
      const userStore = useUserStore();
      const currentUser = userStore.currentUser;

      if (currentUser) {
        let permissions = currentUser.permissions.map((u) => u.name);
        if (userStore.currentAppClient) {
          permissions = currentUser.products?.map((u) => u.name) ?? [];
        } else if (product === "audience_activation") {
          // TODO: remove this when new permissions are live. this is new permission being introduced
          return true;
        }
        return permissions.includes(product);
      }
      return false;
    },
    $hasRole: (role) => {
      const userStore = useUserStore();
      const currentUser = userStore.currentUser;

      if (currentUser) {
        return currentUser.roles.some((r) => r.name === role);
      }
      return false;
    },
  },
};
